"use client";
import { clickEvent } from "@/lib/atInternetTags";
import clsx from "clsx";
import Link from "next/link";
import { Intermedes as LogoSVG } from "../icons/Intermedes";

type Props = {
  isHeaderTransparent: boolean;
  pathname?: string;
};
export const Logo = ({ pathname = "/", isHeaderTransparent }: Props) => {
  return (
    <Link
      href={{ pathname, query: {} }}
      className={clsx(
        "flex items-center brightness-0 transition-[filter] no-underline w-32 flex-[0_0_128px] sm:w-40 sm:flex-[0_0_160px]",
        {
          "xl:invert": isHeaderTransparent,
        },
      )}
      onClick={() =>
        clickEvent({
          event: "click.navigation",
          click: "logo_intermedes",
          click_chapter1: "menu",
        })
      }
    >
      <LogoSVG className="w-full" />
    </Link>
  );
};
